import axios from 'axios';

axios.defaults.baseURL = '/api/discussions/recent';

export default {
    getRecentDiscussions: function() {
        return axios.get();
    },
    getRecentDiscussionsByCommunity: function(communityId) {
        return axios.get(`/${communityId}`);
    }
}